import { render, staticRenderFns } from "./CandidateWizardRegistration.vue?vue&type=template&id=dc010d6a&"
import script from "./CandidateWizardRegistration.vue?vue&type=script&lang=js&"
export * from "./CandidateWizardRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports